import React from 'react';
import type { StructuredCallout } from './types';

const calloutStyles: Record<string, string> = {
  info: 'border border-brand-border border-l-4 border-l-brand bg-brand-subtle shadow-sm',
  success: 'border border-(--status-positive)/30 border-l-4 border-l-(--status-positive) bg-status-positive-bg shadow-sm',
  warning: 'border border-(--status-attention)/30 border-l-4 border-l-(--status-attention) bg-status-attention-bg shadow-sm',
  critical: 'border border-(--status-negative)/30 border-l-4 border-l-(--status-negative) bg-status-negative-bg shadow-sm',
  'clinical-highlight': 'border border-primary/20 border-l-4 border-l-primary bg-primary/5 shadow-sm',
};

export function ClinicalCallout({ callout }: { callout: StructuredCallout }) {
  const style =
    calloutStyles[callout.type] ??
    'border-l-text-tertiary bg-surface-sunken/30';

  return (
    <div
      className={`rounded p-4 my-4 ${style}`}
      role="region"
      aria-label={callout.title}
    >
      {callout.title && (
        <h4 className="text-sm font-medium tracking-tight text-foreground mb-1.5">{callout.title}</h4>
      )}
      <p className="text-sm leading-[1.7] text-text-tertiary">{callout.body}</p>
    </div>
  );
}
